import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius, shadow, spacing } from '@mobi/component-library/Foundations'

export const Container = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; topComponent?: React.ReactNode; onClick?: React.MouseEventHandler }
>(({ children, topComponent, onClick }, ref) => {
  return (
    <CardStyled ref={ref} data-testid='BetCard' data-has-on-click={!!onClick}>
      <div>{topComponent}</div>

      <div onClick={onClick}>{children}</div>
    </CardStyled>
  )
})

Container.displayName = 'Container'

// ======
// Styles
// ======

const CardStyled = styled.div({
  overflow: 'hidden',
  border: '1px solid ' + colors.neutral[300],
  borderRadius: radius.lgx3,
  boxShadow: shadow.xs,
  fontFamily: font.family.primary,

  '> div:first-of-type': {
    overflow: 'hidden',
    borderTopLeftRadius: radius.lgx3,
    borderTopRightRadius: radius.lgx3,

    ':empty': { display: 'none' },
  },

  '> div:last-of-type': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    padding: spacing.sm,
    backgroundColor: colors.white,
    borderBottomLeftRadius: radius.lgx3,
    borderBottomRightRadius: radius.lgx3,
  },

  '&[data-has-on-click="true"]': {
    userSelect: 'none',
    transition: 'all 0.3s ease',

    '@media (hover: hover) and (pointer: fine)': {
      '> div:last-of-type': { transition: 'all 0.3s ease' },
      '&:hover > div:last-of-type': { backgroundColor: colors.surface[50] },
    },

    '&:active:not(:has(button:active))': { transform: 'scale(0.95)' },
    '&:active:not(:has(button:active)) > *': { opacity: 0.75 },
  },
})
